// @ts-nocheck

export const KeyCodes = Object.freeze({
  TAB: 9,
  ENTER: 13,
  UP_ARROW: 38,
  DOWN_ARROW: 40,
  LEFT_ARROW: 37,
  RIGHT_ARROW: 39,
  ESCAPE: 27,
});
